var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarningRound = function SvgWarningRound(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EB5757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1348_3012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99656 10.0293C7.45136 10.0293 7.00781 10.4728 7.00781 11.018C7.05752 12.3279 8.9358 12.3276 8.9853 11.018C8.9853 10.4728 8.54174 10.0293 7.99656 10.0293Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98605 4.45659C8.4954 3.84795 7.50044 3.84765 7.00959 4.45662C6.7638 4.74924 6.6606 5.13288 6.72648 5.50917C6.92294 6.63159 7.20018 8.21576 7.3246 8.92722C7.46401 9.6761 8.5317 9.67587 8.67093 8.92725L9.26917 5.50917C9.33505 5.13289 9.23186 4.74924 8.98605 4.45659Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1348_3012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
export default SvgWarningRound;